import { ArrowLeft } from "lucide-react";
import React from "react";
import {
  Button,
  CSSObject,
  MantineTheme,
  useMantineTheme,
} from "@mantine/core";
import { useNavigate } from "react-router-dom";

interface BackButtonProps {
  to?: string;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
}

const getBackButtonStyles = (theme: MantineTheme): { root: CSSObject } => ({
  root: {
    color: theme.black,
    fontFamily: theme.fontFamily,
    fontWeight: 600,
    fontSize: theme.fontSizes.sm,
    padding: `${theme.spacing.xs}px ${theme.spacing.sm}px`,
    "&:hover": {
      backgroundColor: theme.fn.rgba(theme.black, 0.05),
    },
  },
});

const BackButton: React.FC<BackButtonProps> = ({
  to,
  onClick,
  children,
  className,
}) => {
  const navigate = useNavigate();
  const theme = useMantineTheme();

  const handleClick = (): void => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    }
  };

  return (
    <Button
      variant="subtle"
      leftIcon={<ArrowLeft size={18} />}
      onClick={handleClick}
      styles={getBackButtonStyles(theme)}
      className={className}
    >
      {children}
    </Button>
  );
};

export default BackButton;
